import { render, staticRenderFns } from "./accommodationOrder.vue?vue&type=template&id=2cb756b4&scoped=true&"
import script from "./accommodationOrder.vue?vue&type=script&lang=js&"
export * from "./accommodationOrder.vue?vue&type=script&lang=js&"
import style0 from "./accommodationOrder.vue?vue&type=style&index=0&id=2cb756b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb756b4",
  null
  
)

export default component.exports